<template>
	<div class='form'>
		<Form :model="contact" :label-position='"top"' ref='contactForm' :rules='rules'>
			<FormItem>
                <RadioGroup v-model="contact.hasPcNo">
                    <Radio size='large' label="0">
                        <span>我已有顾客编号</span>
                    </Radio>
                    <Radio size='large' label="1">
                        <span>我还没顾客编号</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem v-if='contact.hasPcNo == 0' label='顾客编号' prop='Vipno'>
            	<Input size='large' v-model='contact.Vipno' placeholder='顾客编号'></Input>
            </FormItem>
            <FormItem label='姓名' prop='UserName'>
            	<Input size='large' v-model='contact.UserName' placeholder='用户姓名'></Input>
            </FormItem>
            <FormItem key='Email' label='电子邮件' prop='Email'>
            	<Input size='large' v-model='contact.Email' placeholder='电子邮件'></Input>
            </FormItem>
            <FormItem key='MobilePhone' label='电话' prop='MobilePhone'>
            	<Input size='large' v-model='contact.MobilePhone' placeholder='电话'></Input>
            </FormItem>
            <FormItem label='问题类型' prop='QuestionType'>
            	<Select v-model='contact.QuestionType' size='large' placeholder='请选择问题类型' filterable>
            		<Option v-for='option in options' :value='option.value' :key='option.value' :label='option.label'> </Option>
            	</Select>
            </FormItem>
            <FormItem label='问题' prop='Question'>
            	<Input size='large' type='textarea' v-model='contact.Question' placeholder='问题描述'></Input>
            </FormItem>
            <FormItem v-if='contact.hasPcNo == 0' label='附件(最多上传10个，所有附件一共不大于100M)'>
            	<div style='display:flex;align-items: center;gap:10px;flex-wrap:wrap;'>
	            	<div v-for='(item,index) in imgs' style='width:100px;height:100px;position:relative'>
	            		<img style='width:100%;height:100%;' :src="item.type.indexOf('image') == 0 ?item.uri:require('../../assets/fileIcon/video.png')" alt="">
	            		<div @click='removeImg(item,index)' style='position:absolute;bottom: 0;right: 0;width:30px;height:30px;'>
	            			<Icon size='30' type="ios-close-circle" />	
	            		</div>
	            		
	            	</div>
					<imageUpload :limitSize='0' v-if='imgs.length < 10' style='background: #eee;width:100px;height:100px;' :loading='imageLoading' @select='selectCard' :type='"QuestionImg"' accept='image/*,video/*'></imageUpload>
            	</div>
				<p class="error" style="text-align: center;">{{upload_error}}</p>
            </FormItem>
            <FormItem>
            	<div style="text-align: center;">
            		<Button style='width: 200px;' type='primary' size='large' @click='submit'>提交</Button>
            	</div>
            	
            </FormItem>
		</Form>
	</div>
</template>

<script>
	import {RE_PCNO,RE_PHONE,RE_EMAIL} from '@/components/common/regex'
	import imageUpload from '@/components/common/imageUpload'
	import {formValid} from '@/components/common/mixin';
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				contact:{
					hasPcNo:'0',
					Vipno:null,
					UserName:null,
					Email:null,
					MobilePhone:null,
					QuestionType:null,
					Question:null,
					QuestionImg:null,
					type:null,
					Isprocess:0,
				},
				imgs:[],
				totalSize:0,
				imageLoading:false,
				upload_error:null,
				rules:{
					Vipno:[
						{required: true,message: '这是必填项', trigger: 'blur'},
						{type:'string',message:'无效的顾客编号',trigger: 'blur',pattern:RE_PCNO},
					],
					UserName:[
						{required: true,message: '这是必填项', trigger: 'blur'},
					],
					Email:[
						// {required: true,message: '这是必填项', trigger: 'blur'},
						{type:'string',message:'邮箱格式不正确',trigger: 'blur',pattern:RE_EMAIL},
					],
					MobilePhone:[
						{required: true,message: '这是必填项', trigger: 'blur'},
						{type:'string',message:'请输入正确的中国大陆11位手机号码',trigger: 'blur',pattern:RE_PHONE},
					],
					QuestionType:[
						{required: true,message: '这是必选项', trigger: 'change'},
					],
					Question:[
						{required: true,message: '这是必填项', trigger: 'blur'},
					],
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[formValid],
		components: {
			imageUpload,
		},
		computed: {
			...mapState({

			}),
			options(){
				if (this.contact.hasPcNo == 0) {
					return [{value:'1',label:'信息咨询',},{value:'2',label:'网站资料修改',},{value:'3',label:'产品咨询',},{value:'4',label:'开发票',},{value:'5',label:'售后服务',},{value:'6',label:'违规举报',},]
				} else {
					return [{value:'7',label:'新用户咨询',}]
				}
				
			}
		},
		methods: {
			...mapActions([
				'postFeedbackAction',
				'loadFileAction',
				'uploadImageAction',
			]),
			async initData(){

			},
			isValid(item){
				let now = new Date
				let valid = true
				if (item.validFrom) {
					valid = now >= item.validFrom
				}
				if (item.validTo) {
					valid = now <= item.validTo
				}
				return valid
			},
			removeImg(item,dindex){
				this.totalSize -= item.size
				this.imgs = this.imgs.filter((item,index)=>index != dindex)
			},
			async selectCard(value, file){
				console.log(file.size)
				if (this.totalSize + file.size > 100*1024*1024) {
					this.$Modal.warning({
						title:'提示',
						content:'所有附件一共不能大于100M'
					})
					return
				}
				this.imageLoading = true;
                let response = await this.uploadImageAction({file,module:'Feedback'});
                this.imageLoading = false;
                if (response.success) {
                	this.imgs.push({
                		uri:response.value,
                		type:file.type,
                		size:file.size
                	})
                	this.totalSize += file.size
                }else {
                	this.upload_error = '图片上传失败'
                }
			},
			async submit(){
				this.contact.QuestionImg = this.imgs.map(item=>item.uri).join('|')
				let valid = await this.validate('contactForm');
				if (valid) {
					this.contact.Email = this.contact.Email||''
					let response = await this.postFeedbackAction(this.contact)
					if (response.Code == 1) {
						this.$Modal.success({
							title:'提交问题',
							content:'问题提交成功',
							onOk:()=>{
								this.$router.push('/home')
							}
						})
					}else {
						this.$Modal.error({
							title:'提交问题',
							content:response.msg,
						})
					}
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	@import '@/style/common';
	.form {
		padding: 0 20px;
	}
	.img-responsive {
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	.en {
		@include fontSize($font-size-12);
	}
	.error {
		// position:absolute;
		top:28px;
		color: red;
	}
	
</style>